// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"icon-button_IconButton__s6r03"};